// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchResult } from "./types";

export const isPostDecisioningStudioAgentsAppGroupIdDsaIdLaunchResult =
  objectOf<PostDecisioningStudioAgentsAppGroupIdDsaIdLaunchResult>({
    success: boolean,
  });
